import React from 'react';
import compose from 'recompose/compose';
import { injectIntl } from 'react-intl';
import Input from '../../components/Input';
import Button from '../../components/Button';
import WithValidation from '../../lib/WithValidation';
import require from '../../lib/WithValidation/rules/required';
import translate from '../../lib/utils/translate';
import Icon from '../../components/Icon';

var SignIn = function SignIn(_ref) {
  var errors = _ref.errors,
      intl = _ref.intl,
      _onBlur = _ref.onBlur,
      onSubmit = _ref.onSubmit,
      isLoading = _ref.isLoading,
      email = _ref.email,
      handleChangeEmail = _ref.handleChangeEmail,
      handleToggleRememberEmail = _ref.handleToggleRememberEmail,
      _ref$shouldRememberEm = _ref.shouldRememberEmail,
      shouldRememberEmail = _ref$shouldRememberEm === undefined ? false : _ref$shouldRememberEm,
      _ref$shouldAutoFocus = _ref.shouldAutoFocus,
      shouldAutoFocus = _ref$shouldAutoFocus === undefined ? true : _ref$shouldAutoFocus;
  return React.createElement(
    'form',
    { className: 'form', onSubmit: onSubmit },
    React.createElement(Input, {
      className: 'layout-item-full-width',
      name: 'username',
      value: email,
      onChange: handleChangeEmail,
      onBlur: function onBlur() {
        return _onBlur('username', email);
      },
      label: translate({ id: 'label.username_or_email' }, intl),
      autoFocus: shouldAutoFocus && !email,
      autoComplete: 'username',
      icon: React.createElement(Icon, { icon: 'envelope' }),
      status: errors.username && 'failure',
      statusText: errors.username && translate({ id: errors.username }, intl)
    }),
    React.createElement(Input, {
      className: 'layout-item-full-width',
      type: 'password',
      name: 'password',
      label: translate({ id: 'label.password' }, intl),
      autoFocus: shouldAutoFocus && email,
      autoComplete: 'current-password',
      icon: React.createElement(Icon, { icon: 'lock' }),
      status: errors.password && 'failure',
      statusText: errors.password && translate({ id: errors.password }, intl)
    }),
    React.createElement(Input, {
      className: 'layout-item-full-width remember-email-checkbox',
      type: 'checkbox',
      label: translate({
        id: 'label.remember-email',
        defaultMessage: 'Remember email'
      }, intl),
      value: shouldRememberEmail,
      onChange: handleToggleRememberEmail,
      name: 'remember-email'
    }),
    React.createElement(
      Button,
      {
        className: 'button primary wide',
        type: 'submit',
        isLoading: !!isLoading },
      translate({ id: 'action.button.login' }, intl)
    )
  );
};

var rules = {
  username: [[require, 'error.empty.username_or_email']],
  password: [[require, 'error.empty.password']]
};

export default compose(WithValidation(rules), injectIntl)(SignIn);